import React from "react";

import Navbar from "../Navbar/Navbar";

interface IProps {
  children: React.ReactNode;
  className?: string;
  hideNavbar?: boolean;
}

const LayoutLanding = ({
  children,
  className,
  hideNavbar,
}: IProps) => {
  return (
    <>
      {!hideNavbar && <Navbar />}
      <main className={className}>{children}</main>
    </>
  );
};

export default LayoutLanding;
